<template>
<section>
	<h3>Revisions Log</h3>

	<button v-if="!showLog" v-on:click="showLog = true" class="btn btn-light">
		<i class="fa fa-list"></i>
		Show Revisions Log
	</button>

	<button v-else v-on:click="showLog = false" class="btn btn-light">
		<i class="fa fa-eye-slash"></i>
		Hide Revisions Log
	</button>

	<template v-if="showLog">
		<ul v-if="invoiceRevisions && invoiceRevisions.length > 0" class="list-group mt-2">
			<li v-for="(revision, index) in invoiceRevisions" class="list-group-item">
				<div class="d-flex justify-content-between">
					<span v-if="revision.revision_num == 0">Original</span>
					<span v-else>Revision #{{ revision.revision_num }}</span>
					<span>{{ formatDateTimeToLocal(revision.issue_date) }}</span>
					<a href="#" v-on:click.prevent="$emit('restoreClick',revision)">Restore</a>
				</div>	
			</li>
		</ul>

		<p v-else>No revisions</p>

	</template>

</section>
</template>
<script type="text/javascript">


export default {
	name: "RevisionLog",
	props: [
		"invoiceRevisions",
	],
	data() {
		return {
			showLog: false
		}
	},
	methods: {
		showDetails(index) {
			this.detailsVisible = true
			this.detailIndex = index
		},
		hideDetails(index) {
			this.detailsVisible = false
			this.detailIndex = null
		}
	}
}
</script>